var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.max)?_c('div',{staticClass:"progressbar"},[_c('div',{staticClass:"h-[0.3em] w-full bg-[#ededed]"},[_c('div',{staticClass:"h-full bg-success transition-all",style:({ width: `${(_vm.value / _vm.max) * 100}%` })})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }